/**
 * CalculatorShell — chrome for every field-takeoff calculator.
 *
 * Provides the back button, header, and layout. Each calculator owns its
 * own inputs/outputs/Add-to-estimate button as children — keeps state and
 * formula logic local to the calc.
 */

import React from 'react';
import { useIdioma } from '../../../i18n/idioma';
import { ArrowLeft, LucideIcon } from 'lucide-react';

interface CalculatorShellProps {
  name: string;
  description: string;
  Icon: LucideIcon;
  onBack: () => void;
  children: React.ReactNode;
}

const CalculatorShell: React.FC<CalculatorShellProps> = ({ name, description, Icon, onBack, children }) => {
    const { t } = useIdioma();
  return (
    <div className="flex flex-col h-full">
      <div className="px-5 py-4 border-b border-acero-200 flex items-start gap-3">
        <button
          onClick={onBack}
          className="p-2 -ml-2 mt-0.5 text-acero-500 hover:text-navy-950 hover:bg-acero-100 rounded-lg transition-colors duration-150 shrink-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-400"
          aria-label={t('calculadoras.shell.volver')}
        >
          <ArrowLeft size={16} />
        </button>
        <div className="w-9 h-9 grid place-items-center bg-acero-100 text-acero-600 rounded-lg shrink-0">
          <Icon size={18} />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold tracking-tight text-navy-950 text-base leading-tight">{name}</h3>
          <p className="text-[11px] text-acero-500 mt-0.5 leading-snug">{description}</p>
        </div>
      </div>
      <div className="flex-1 min-h-0 overflow-y-auto custom-scrollbar p-5 space-y-5">
        {children}
      </div>
    </div>
  );
};

export default CalculatorShell;
